export const colors = {
  yellow: '#fecf33',
  lightOrange: '#fdbd39',
  peach: '#ee6723',
  purple: '#887fff',
  link: '#4a90e2',
  green: '#3a6a4a',
}